import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import InputSelectField from './InputSelectField';
import PaymentApplicationMonth from '../../Entities/PaymentApplicationMonth';
import { queryGetPaymentApplicationMonths } from '../../Queries';
import './PaymentApplicationMonthsTable.scss';

const PaymentApplicationMonthsTable = (props) => {
  const [paymentApplicationMonths, setPaymentApplicationMonths] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(true);

  const fields =  [
    'id',
    'facility_id',
    'month',
    'year',
    'status',
    'created_at',
    'updated_at',
    'deleted_at',
  ];

  useEffect(() => {
    fetchMonthData();
  }, []);

  useEffect(() => {
    if(!props.editMode){
      fetchMonthData();
    }
  }, [props.editMode]);

  useEffect(() => {
    props.onValueChange("payment_application_months", paymentApplicationMonths);
  }, [paymentApplicationMonths]);

  async function fetchMonthData() {
    setIsTableLoading(true);
    const facilityId = props.settings.fields.facility_id.value;
    const response = await queryGetPaymentApplicationMonths({ facility_id: facilityId }, fields);
    const responseMonths = response.data.getPaymentApplicationMonths;

    let entityMonths = [];
    if (responseMonths.length) {
      entityMonths = responseMonths.map(month => PaymentApplicationMonth.createFromQueryValues(month));
    } else {
      entityMonths = PaymentApplicationMonth.createDefaultYearOfMonths(facilityId);
    }

    setPaymentApplicationMonths(entityMonths);
    setIsTableLoading(false);
  }

  const editMode = props.editMode;

  const statusOptions = props.fieldConfiguration.paymentApplicationMonth.status.options;
  const monthOptions = props.fieldConfiguration.paymentApplicationMonth.month.options;

  const getFormattedMonths = () => {
    if (paymentApplicationMonths.length) {
      return [...new Array(12)].map((_, i) => {
        const monthMoment = moment().subtract(12-i, 'months');
        const month = paymentApplicationMonths.find(appMonth => appMonth.fields.month.value === monthMoment.format('MMM'));

        const monthLabel = monthOptions.find(option => option.value === month.fields.month.value).label;
        const label = `${monthLabel} ${month.fields.year.value}`;
        const value = month.fields.status.value;

        return {
          month: month.fields.month.value,
          value,
          label,
        };
      });
    }

    return [];
  }
  const formattedMonths = getFormattedMonths();

  const onMonthValueChange = (month, value) => {
    const newMonths = [
      ...paymentApplicationMonths
    ];

    const indexToUpdate = newMonths.findIndex(({ fields }) => fields.month.value === month);
    newMonths[indexToUpdate].fields.status.value = value;

    setPaymentApplicationMonths(newMonths);
  }

  return (
    <>
    {!isTableLoading && 
    <div className='payment-application-month-table'>
      <table>
        {formattedMonths.map((month, i) => 
          (
            <tr>
              <th>
                {month.label}
              </th>
              <td>
                <InputSelectField
                  inputId={"parkchirp-payment-application--prior-month-application-month-" + i}
                  value={month.value}
                  options={statusOptions}
                  editMode={editMode}
                  onChange={value => { onMonthValueChange(month.month, value) }}
                />
              </td>
            </tr>
          )
        )}
      </table>
    </div>
    }
    </>
  );
}

export default PaymentApplicationMonthsTable;
